import PeopleContactsReducer, {
  Actions as PeopleContactsActions,
  initialState as initialPeopleContactsState,
  PeopleContactsState,
} from 'src/app/PeopleContacts/redux/peopleContacts.reducer'
import { invitePeopleRouteProps } from 'src/navigation/routeProps'
import { createFlyoutReducer } from 'src/redux/genericReducers'

export type InvitePeopleState = {
  contactsFullPaginatedData: PeopleContactsState
}

export const initialState: InvitePeopleState = {
  contactsFullPaginatedData: initialPeopleContactsState,
}

export type Actions = PeopleContactsActions

const CoreInvitePeopleReducer = (
  state = initialState,
  action: Actions,
): InvitePeopleState => ({
  contactsFullPaginatedData: PeopleContactsReducer(
    state.contactsFullPaginatedData,
    action as PeopleContactsActions,
  ),
})

const InvitePeopleReducer = createFlyoutReducer(
  invitePeopleRouteProps,
  initialState,
  CoreInvitePeopleReducer,
)

export default InvitePeopleReducer
